// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"contactMobile-module--wrapper--2BmX-","logos":"contactMobile-module--logos--3ULMU"};